import React, { useState } from 'react';
import StrategyCard from './StrategyCard';
import { FaLightbulb, FaCheck } from 'react-icons/fa';

const StrategySelectionStep = ({ sessionId, strategies, onStrategySelect, loading }) => {
    const [selectedStrategyId, setSelectedStrategyId] = useState(null);

    const handleStrategySelect = (strategyId) => {
        setSelectedStrategyId(strategyId);
        onStrategySelect(strategyId);
    };

    return (
        <div className="space-y-8">
            {/* Header */}
            <div className="text-center">
                <div className="flex justify-center mb-4">
                    <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center">
                        <FaLightbulb className="text-purple-500 text-2xl" />
                    </div>
                </div>
                <h2 className="text-2xl font-bold text-gray-900 mb-2">
                    Estrategias Generadas
                </h2>
                <p className="text-gray-600">
                    Selecciona la estrategia que mejor se adapte a tu negocio
                </p>
            </div>

            {/* Strategies Comparison */}
            <div className="bg-white rounded-lg shadow-lg p-8">
                <div className="mb-6">
                    <h3 className="text-xl font-bold text-gray-900 mb-2">
                        Comparación de Estrategias
                    </h3>
                    <p className="text-gray-600">
                        Hemos generado {strategies?.length || 0} estrategias basadas en tu objetivo seleccionado
                    </p>
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                    {strategies && strategies.map((strategy, index) => (
                        <StrategyCard
                            key={strategy.id}
                            strategy={strategy}
                            selected={selectedStrategyId === strategy.id}
                            onSelect={handleStrategySelect}
                            position={index + 1}
                        />
                    ))}
                </div>

                {selectedStrategyId && (
                    <div className="mt-8 text-center">
                        <div className="flex items-center justify-center mb-4">
                            <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mr-4">
                                <FaCheck className="text-green-500 text-xl" />
                            </div>
                            <div className="text-left">
                                <h4 className="font-semibold text-gray-900">
                                    Estrategia Seleccionada
                                </h4>
                                <p className="text-sm text-gray-600">
                                    Generando tácticas específicas...
                                </p>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default StrategySelectionStep; 